// extracted by mini-css-extract-plugin
export default {"h":"styles_h__yZNDk"};